<template>
  <div>
    <v-snackbar v-model="snackbarToggle" timeout="1200" rounded>
      You can't set a reminder for a closed conversation
    </v-snackbar>
    <v-dialog v-if="convo && convo.convo_id" v-model="reminderDialog" max-width="700px">
      <v-card>
        <v-card-title>
          <span v-if="!hasReminder" class="text-h6">Set Conversation Reminder</span>
          <span v-else class="text-h6">Edit Conversation Reminder</span>
          <v-spacer></v-spacer>
          <span class="text-h6">{{ convo.convo_name }}</span>
        </v-card-title>
        <v-card-text class="column justify-center m10">
          <QuickReminderMenu
            :has-reminder="hasReminder"
            :existing-date="reminderDate"
            @select="_setReminder"
            @remove="_deleteReminder"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ConvoSerice from "@/services/convoService";
import colorMixin from "@/mixins/colorMixin";
import { mapGetters } from "vuex";
import eventBus from "@/eventBus";
import {DateFormats} from "../../constants/formats.js"
import QuickReminderMenu from "@/components/Messenger/QuickReminderMenu.vue";
export default {
  name: "ReminderPanel",
  mixins: [colorMixin],
  components: { QuickReminderMenu },
  props: {
    // used to activate the reminder dialog
    toggleDialog: { type: Boolean, default: false },
    // the convo for the reminder
    convo: { type: Object, default: null },
  },
  data() {
    return {
      reminderDialog: false,
      snackbarToggle: false,
      reminderDate: this.dayjs().add(1, "minute").format(DateFormats.DATE_TIME_FORMAT_24H),
    };
  },
  computed: {
    ...mapGetters(["userId"]),
    minReminderTime() {
      return this.dayjs().add(1, "minute").format(DateFormats.DATE_TIME_FORMAT_24H);
    },
    // true if there is already a reminder set for this convo for the current user
    hasReminder() {
      this.convo.convo_reminders.some((r) =>{
        if ( r.reminder_for_who === this.userId) {
          console.log (r);
        }
      } )
      return (
        this.convo &&
        this.convo.convo_reminders &&
        this.convo.convo_reminders.some((r) => r.reminder_for_who === this.userId)
      );
    },
  },
  watch: {
    toggleDialog() {
      if (!this.convo || !this.convo.convo_id) this.snackbarToggle = !this.snackbarToggle;
      this.reminderDialog = !this.reminderDialog;

      // if a reminder already exists, set the date and time to reflect the existing reminder
      if (this.hasReminder) {
        let r = this.convo.convo_reminders.find((r) => r.reminder_for_who === this.userId);
        //this.reminderDate = this.minReminderTime;
        console.log(r);
        this.reminderDate =this.dayjs(r.reminder_date).format(DateFormats.DATE_TIME_FORMAT_24H);
        console.log(this.dayjs(this.reminderDate).format(DateFormats.DATE_TIME_FORMAT_24H));
      } else {
        this.reminderDate = this.minReminderTime;
      }
    },
  },
  methods: {
    // date is an ISO string emitted by QuickReminderMenu (preset or custom)
    _setReminder(date) {
      // if we need to create a new reminder
      if (!this.hasReminder) {
        ConvoSerice.addReminder(this.convo.convo_id, date)
          .then(() => {
            this.reminderDialog = false;
          })
          .catch((e) => {
            console.log(e);
            eventBus.$emit("alert", "Error adding reminder");
          });
      }
      // if we need to modify the existing reminder
      else {
        ConvoSerice.updateReminder(this.convo.convo_id, date)
          .then(() => {
            this.reminderDialog = false;
          })
          .catch((e) => {
            eventBus.$emit("alert", "Error updating reminder");
            console.log(e);
          });
      }
    },
    _deleteReminder() {
      ConvoSerice.deleteReminder(this.convo.convo_id)
        .then(() => {
          this.reminderDialog = false;
        })
        .catch((e) => {
          eventBus.$emit("alert", "Error deleting reminder");
          console.log(e);
        });
    },
  },
};
</script>